import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Auth } from '@aws-amplify/auth';

const defaultAppSyncConfig = {
  region: process.env.REACT_APP_AWS_REGION,
  graphqlEndpoint: process.env.REACT_APP_AWS_GRAPHQL_END_POINT,
  authenticationType: process.env.REACT_APP_AWS_AUTHENTICATION_TYPE,
  apiKey: 'null'
};

export let appSyncClient = null;

export const setAWSAppSyncClient = async appSyncConfig => {
  const config = { ...defaultAppSyncConfig, ...appSyncConfig };
  if (!config.graphqlEndpoint) return null;

  const httpLink = new HttpLink({
    uri: config.graphqlEndpoint
  });

  const authLink = setContext(async (_, { headers }) => {
    // Default to returning existing headers (no auth)
    let nextHeaders = { ...headers };

    try {
      if (
        config.authenticationType === 'OPENID_CONNECT' ||
        config.authenticationType === 'AMAZON_COGNITO_USER_POOLS'
      ) {
        const session = await Auth.currentSession();
        const token = session.getAccessToken().getJwtToken();
        nextHeaders = {
          ...nextHeaders,
          Authorization: token
        };
      } else if (config.authenticationType === 'AWS_IAM') {
        // For IAM auth you normally need request signing.
        // This app historically used Cognito token auth; keep this as a no-op.
        nextHeaders = { ...nextHeaders };
      } else if (config.authenticationType === 'API_KEY') {
        nextHeaders = {
          ...nextHeaders,
          'x-api-key': config.apiKey
        };
      } else {
        // defaults / unknown type: try JWT token
        const session = await Auth.currentSession();
        const token = session.getAccessToken().getJwtToken();
        nextHeaders = {
          ...nextHeaders,
          Authorization: token
        };
      }
    } catch (e) {
      // If there's no session, we still allow unauthenticated queries if the API supports it.
      nextHeaders = { ...nextHeaders };
    }

    return {
      headers: nextHeaders
    };
  });

  appSyncClient = new ApolloClient({
    link: ApolloLink.from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network'
      },
      query: {
        fetchPolicy: 'network-only'
      }
    }
  });

  return appSyncClient;
};

export const gqlQuery = ({ client = appSyncClient, ...data }) =>
  client.query({ ...data });

export const gqlMutation = ({ client = appSyncClient, ...data }) =>
  client.mutate({ ...data });
